import FrontPage from '@/components/pages/frontpage/FrontPageController';
import getStaticProps from '@/components/pages/frontpage/FrontPageStaticProps';

export default FrontPage;
export { getStaticProps };
